export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SiteHeader.vue?vue&type=template&id=10b4335a&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SiteHeader.vue?vue&type=template&id=10b4335a&scoped=true&
// module id = 83
// module chunks = 0